import { render, staticRenderFns } from "./ResultOne.vue?vue&type=template&id=ecc42da8&scoped=true&lang=pug"
import script from "./ResultOne.vue?vue&type=script&lang=ts"
export * from "./ResultOne.vue?vue&type=script&lang=ts"
import style0 from "./ResultOne.vue?vue&type=style&index=0&id=ecc42da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc42da8",
  null
  
)

export default component.exports